module.exports = __webpack_public_path__ + "img/coffee.7b0396d7.svg";